(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-text"] && !Shopify.designMode) return;
  try {
    
// アコーディオン開閉
const showMores = Array.from(document.querySelectorAll(".show_more"));
showMores.forEach((item) => {
  item.addEventListener("click", function () {
    this.classList.toggle("active");
    const accCnt = this.previousElementSibling;
    if (!accCnt.style.maxHeight) {
      accCnt.style.maxHeight = accCnt.scrollHeight + "px";
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
